import React, { useMemo } from "react";
import {
  Edit as EditIcon,
  ContentCopy as DuplicateIcon,
  Delete as DeleteIcon,
} from "@mui/icons-material";

import ActionsDropdown from "../../../../../components/Dropdown/ActionsDropdown";
import { DropdownAction } from "../../../../../components/Dropdown/types";
import { RateRowMenuProps } from "./types";

export const RateRowMenu: React.FC<RateRowMenuProps> = ({
  rate,
  onEditRate,
  onDuplicateRate,
  onDeleteRate,
}) => {
  const actions = useMemo<DropdownAction[]>(
    () => [
      {
        id: "edit",
        label: "Edit",
        icon: <EditIcon fontSize="small" />,
        onClick: () => onEditRate?.(rate),
        show: Boolean(onEditRate),
      },
      {
        id: "duplicate",
        label: "Duplicate",
        icon: <DuplicateIcon fontSize="small" />,
        onClick: () => onDuplicateRate?.(rate),
        show: Boolean(onDuplicateRate),
      },
      {
        id: "delete",
        label: "Delete",
        icon: <DeleteIcon fontSize="small" />,
        onClick: () => onDeleteRate?.(rate),
        variant: "destructive" as const,
        show: Boolean(onDeleteRate),
      },
    ],
    [rate, onEditRate, onDuplicateRate, onDeleteRate],
  );

  return (
    <ActionsDropdown
      compact
      dropdownActions={actions}
      testId={`rate-row-menu-${rate.id}`}
    />
  );
};

RateRowMenu.displayName = "RateRowMenu";
